import React, { useEffect, useState, useRef, useCallback } from 'react'
import { HashRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'
import ModernLayout from './components/ModernLayout'
import ScrollToTop from './components/ScrollToTop'
import ModernHomePage from './pages/HtdHomePage'
import ModernDashboardPage from './pages/ModernDashboardPage'
import ModernLobbyCasinoPage from './pages/ModernLobbyCasinoPage'
import ModernPromotionPage from './pages/ModernPromotionPage'
import ModernLiveTvPage from './pages/ModernLiveTvPage'
import ModernCashbackPage from './pages/ModernCashbackPage'
import ModernMemberPage from './pages/ModernMemberPage'
import ModernHowtoPage from './pages/ModernHowtoPage'
import ModernContactPage from './pages/ModernContactPage'
import ModernTopupPage from './pages/ModernTopupPage'
import ModernTopupConfirmPage from './pages/ModernTopupConfirmPage'
import ModernTopupSlipPage from './pages/ModernTopupSlipPage'
import ModernDepositTimeoutPage from './pages/ModernDepositTimeoutPage'
import ModernWithdrawPage from './pages/ModernWithdrawPage'
import ModernPointsLayout from './pages/points/ModernPointsLayout'
import PointsMoneytopointPage from './pages/points/PointsMoneytopointPage'
import PointsPointtomoneyPage from './pages/points/PointsPointtomoneyPage'
import PointsRewardsPage from './pages/points/PointsRewardsPage'
import PointsRewardHistoryPage from './pages/points/PointsRewardHistoryPage'
import PredictionPage from './pages/points/PredictionPage'
import RedEnvelopeDemoPage from './pages/points/RedEnvelopeDemoPage'
import RedEnvelopeGamePage from './pages/points/RedEnvelopeGamePage'
import RedEnvelopeHistoryPage from './pages/points/RedEnvelopeHistoryPage'
import LuckyWheelGamePage from './pages/points/LuckyWheelGamePage'
import BerThongLobbyPage from './pages/points/BerThongLobbyPage'
import BerThongSheetsPage from './pages/points/BerThongSheetsPage'
import BerThongGamePage from './pages/points/BerThongGamePage'
import ScratchLotteryGamePage from './pages/points/ScratchLotteryGamePage'
import ScratchLotteryLobbyPage from './pages/points/ScratchLotteryLobbyPage'
import HuayJackpotLobbyPage from './pages/points/HuayJackpotLobbyPage'
import ModernRewardLayout from './pages/reward/ModernRewardLayout'
import RewardCashbackPage from './pages/reward/RewardCashbackPage'
import RewardLossPage from './pages/reward/RewardLossPage'
import RewardReferPage from './pages/reward/RewardReferPage'
import RewardRankPage from './pages/reward/RewardRankPage'
import ModernLobbyHuayLayout from './pages/lobby-huay/ModernLobbyHuayLayout'
import ModernLobbyHuayListAllPage from './pages/lobby-huay/ModernLobbyHuayListAllPage'
import ModernLobbyHuayYeekeePage from './pages/lobby-huay/ModernLobbyHuayYeekeePage'
import ModernLobbyHuayYeekeeResultPage from './pages/lobby-huay/ModernLobbyHuayYeekeeResultPage'
import ModernLobbyHuayBetPage from './pages/lobby-huay/ModernLobbyHuayBetPage'
import ModernLobbyHuaySetPage from './pages/lobby-huay/ModernLobbyHuaySetPage'
import ModernLobbyHuaySetEditPage from './pages/lobby-huay/ModernLobbyHuaySetEditPage'
import ModernLobbyHuaySetLottoGamePage from './pages/lobby-huay/ModernLobbyHuaySetLottoGamePage'
import ModernLobbyHuayWinNumberPage from './pages/lobby-huay/ModernLobbyHuayWinNumberPage'
import ModernLobbyHuaySlipPage from './pages/lobby-huay/ModernLobbyHuaySlipPage'
import ModernLobbyHuaySlipDetailPage from './pages/lobby-huay/ModernLobbyHuaySlipDetailPage'
import ModernLobbyHuayResultPage from './pages/lobby-huay/ModernLobbyHuayResultPage'
import ModernLobbyHuayLotteryTermsPage from './pages/lobby-huay/ModernLobbyHuayLotteryTermsPage'
import ModernLoginPage from './pages/ModernLoginPage'
import ModernPasscodePage from './pages/ModernPasscodePage'
import ModernRegisterPage from './pages/ModernRegisterPage'
import ModernRegisterCompletePage from './pages/ModernRegisterCompletePage'
import ModernHistoryLayout from './pages/history/ModernHistoryLayout'
import HistoryDepositPage from './pages/history/HistoryDepositPage'
import HistoryWithdrawPage from './pages/history/HistoryWithdrawPage'
import HistoryCreditPage from './pages/history/HistoryCreditPage'
import HistoryGamblePage from './pages/history/HistoryGamblePage'
import HistoryPendingPage from './pages/history/HistoryPendingPage'
import HistoryBtdPage from './pages/history/HistoryBtdPage'
import HistoryRedEnvelopePage from './pages/history/HistoryRedEnvelopePage'
import HistoryGamesLayout, { HistoryGamesIndexRedirect } from './pages/history/HistoryGamesLayout'
import HistoryLuckyWheelPage from './pages/history/HistoryLuckyWheelPage'
import HistoryBerThongPage from './pages/history/HistoryBerThongPage'
import HistoryScratchLotteryPage from './pages/history/HistoryScratchLotteryPage'
import HistoryHuayJackpotPage from './pages/history/HistoryHuayJackpotPage'
import ModernAffiliateLayout from './pages/affiliate/ModernAffiliateLayout'
import AffiliateOverviewPage from './pages/affiliate/AffiliateOverviewPage'
import AffiliateMemberPage from './pages/affiliate/AffiliateMemberPage'
import AffiliateIncomePage from './pages/affiliate/AffiliateIncomePage'
import AffiliateToptenPage from './pages/affiliate/AffiliateToptenPage'
import AffiliateWithdrawalPage from './pages/affiliate/AffiliateWithdrawalPage'
import type { TenantThemeConfig, ColorScheme, TenantContentBlock } from './types/theme'
import { COLOR_SCHEMES } from './types/theme'
import { getThemeById, getDefaultTheme, getActiveThemes } from './config/themes'
import { getTenantContent } from './services/tenantService'
import { parseLiveTvChannels, parseHuayYoutubeLive } from './lib/liveTv'
import { lotteryService } from './services/lotteryService'
import { useSmartWebSocket } from './hooks/useSmartWebSocket'
import usePopupManagerOptimized from './hooks/usePopupManagerOptimized'
import { useAnimateOnScroll } from './hooks/useAnimateOnScroll'
import * as authService from './services/authService'
import { ModernAnnouncementAlert } from './components/ModernAnnouncementAlert'
import PopupModal from './components/PopupModal'
import ThemeSwitcherFloat from './components/ThemeSwitcherFloat'
import ModernMaintenancePage from './pages/ModernMaintenancePage'
import {
  getRuntimeTenantIdSync,
  resolveRuntimeTenantId,
  setRuntimeTenantId,
} from './lib/runtimeTenant'
import {
  fetchMaintenanceStatusCached,
  isInternalStagingHostname,
  type MaintenanceState,
} from '@huay/shared/tenantManagementPublicClient'
import { withApiBaseUrl } from './lib/apiBaseUrl'
import { updateSocialMetaTags } from './utils/socialMeta'

// ─── Maintenance mode ─────────────────────────────────────────────────────────
interface MaintenanceWarning {
  active: boolean
  reason?: string
  estimatedEnd?: string | null
  maintenanceStart?: string | null
  countdownMinutes: number
  secondsLeft: number
}
// WebSocket handles real-time updates; polling is just a fallback
const MAINTENANCE_CHECK_INTERVAL = 30_000

function getApiBaseUrl(): string {
  const sample = withApiBaseUrl('/api/v1/tenant-management/maintenance')
  return sample.replace(/\/api\/v1\/tenant-management\/maintenance$/, '')
}

async function fetchMaintenanceStatus(tenantId?: string): Promise<MaintenanceState> {
  return fetchMaintenanceStatusCached(getApiBaseUrl(), tenantId)
}

// ─── Maintenance Warning Overlay ──────────────────────────────────────────────
const MaintenanceWarningOverlay: React.FC<{ warning: MaintenanceWarning }> = ({ warning }) => {
  const mins = Math.floor(warning.secondsLeft / 60)
  const secs = warning.secondsLeft % 60
  const pct = Math.max(0, (warning.secondsLeft / (warning.countdownMinutes * 60)) * 100)
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 999990,
      background: 'rgba(0,0,0,0.80)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      backdropFilter: 'blur(8px)'
    }}>
      <div style={{
        background: 'linear-gradient(135deg,#0f172a,#1e293b)',
        border: '2px solid #f59e0b',
        borderRadius: 20, padding: '36px 40px', maxWidth: 460, width: '90%',
        boxShadow: '0 0 60px rgba(245,158,11,0.35)',
        textAlign: 'center', color: '#fff', fontFamily: 'sans-serif'
      }}>
        <div style={{ fontSize: 56, marginBottom: 12 }}>⚠️</div>
        <h2 style={{ color: '#f59e0b', fontSize: 22, fontWeight: 700, margin: '0 0 8px' }}>
          ระบบกำลังจะปิดให้บริการชั่วคราว
        </h2>
        {warning.reason && (
          <p style={{ color: '#94a3b8', fontSize: 14, margin: '0 0 16px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.7 }}>
            {warning.reason}
          </p>
        )}
        <div style={{
          background: 'rgba(245,158,11,0.12)', border: '1px solid rgba(245,158,11,0.35)',
          borderRadius: 12, padding: '16px 24px', marginBottom: 20
        }}>
          <p style={{ color: '#64748b', fontSize: 12, margin: '0 0 4px' }}>ระบบจะ logout อัตโนมัติใน</p>
          <div style={{ fontSize: 48, fontWeight: 800, color: warning.secondsLeft <= 30 ? '#ef4444' : '#f59e0b', lineHeight: 1 }}>
            {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
          </div>
          <p style={{ color: '#64748b', fontSize: 12, margin: '6px 0 0' }}>นาที : วินาที</p>
        </div>
        <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 99, height: 6, overflow: 'hidden', marginBottom: 16 }}>
          <div style={{
            height: '100%', background: warning.secondsLeft <= 30 ? '#ef4444' : '#f59e0b',
            width: `${pct}%`, transition: 'width 1s linear, background 0.5s'
          }} />
        </div>
        {warning.maintenanceStart && (
          <p style={{ color: '#64748b', fontSize: 12, margin: '0 0 4px' }}>
            เริ่มปิดระบบ: <strong style={{ color: '#cbd5e1' }}>
              {new Date(warning.maintenanceStart).toLocaleString('th-TH', { timeZone: 'Asia/Bangkok', dateStyle: 'medium', timeStyle: 'short' })}
            </strong>
          </p>
        )}
        {warning.estimatedEnd && (
          <p style={{ color: '#64748b', fontSize: 12, margin: '4px 0 0' }}>
            คาดว่าเปิดอีกครั้ง: <strong style={{ color: '#cbd5e1' }}>
              {new Date(warning.estimatedEnd).toLocaleString('th-TH', { timeZone: 'Asia/Bangkok', dateStyle: 'medium', timeStyle: 'short' })}
            </strong>
          </p>
        )}
        <p style={{ color: '#475569', fontSize: 11, marginTop: 16 }}>กรุณาบันทึกข้อมูลก่อนเวลาหมด</p>
      </div>
    </div>
  )
}

const STORAGE_THEME_KEY = 'huay-htd-theme'

// ป้องกันโหลด theme ซ้ำ (รวมกรณี Strict Mode remount) — ลดโอกาส reload loop
let themeLoadStarted = false

// CDN assets: default ใช้ S3 (huay-cdn-assets-prod), override ได้จาก VITE_CDN_URL หรือ window.CDN_BASE_URL
const DEFAULT_CDN_URL = 'https://huay-cdn-assets-prod.s3.ap-southeast-1.amazonaws.com'
const getAssetConfig = () => ({
  CDN_BASE_URL: import.meta.env.VITE_CDN_URL || (typeof window !== 'undefined' ? (window as Window & { CDN_BASE_URL?: string }).CDN_BASE_URL : undefined) || DEFAULT_CDN_URL,
  CSS_PATH: '/css',
  IMG_PATH: '/img',
  FONTS_PATH: '/fonts',
})

/** Recover OTP bridge callbacks that landed on document URL instead of #/register?… (legacy returnUrl). */
const LineBridgeHashRedirect: React.FC = () => {
  useEffect(() => {
    const docSearch = new URLSearchParams(window.location.search)
    const lineBridge = docSearch.get('lineBridge')
    if (!lineBridge) return

    const hash = window.location.hash
    if (hash.includes('lineBridge=')) return

    const params = new URLSearchParams()
    for (const key of ['lineBridge', 'flowId', 'firebaseUid', 'sessionId', 'errorMessage']) {
      const value = docSearch.get(key)
      if (value) params.set(key, value)
    }

    const query = params.toString()
    const targetHash = query ? `#/register?${query}` : '#/register'
    window.location.replace(`${window.location.origin}${window.location.pathname}${targetHash}`)
  }, [])

  return null
}

const RequireAuthRoute: React.FC = () => {
  const location = useLocation()

  if (!authService.isAuthenticated()) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    )
  }

  return <Outlet />
}

const App: React.FC = () => {
  const [themeConfig, setThemeConfig] = useState<TenantThemeConfig | null>(null)
  const [tenantId, setTenantId] = useState<string>('')
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [maintenance, setMaintenance] = useState<MaintenanceState>({ enabled: false })
  const [maintenanceChecked, setMaintenanceChecked] = useState(() => isInternalStagingHostname())
  const [maintWarn, setMaintWarn] = useState<MaintenanceWarning>({ active: false, countdownMinutes: 0, secondsLeft: 0 })
  const maintWarnTimerRef = useRef<ReturnType<typeof setInterval> | null>(null)
  // ถ้า URL มี viewAsToken ต้องตั้ง true ก่อน render ครั้งแรก เพื่อไม่ให้แสดงหน้า home โดยยังไม่ apply token
  const [viewAsHandling, setViewAsHandling] = useState(() => {
    if (typeof window === 'undefined') return false
    const hasToken = authService.getViewAsTokenFromHash() !== null
    if (import.meta.env.DEV) console.log('[ViewAs] initial viewAsHandling:', hasToken, 'hash:', window.location.hash?.slice(0, 50) + '...')
    return hasToken
  })
  const [viewAsError, setViewAsError] = useState<string | null>(null)
  const themeLoadedRef = useRef(false)

  useAnimateOnScroll()

  // ── Maintenance mode check (poll + WebSocket instant update) ─────────────────
  useEffect(() => {
    let active = true
    let prevEnabled = false

    const check = async (tid?: string) => {
      if (isInternalStagingHostname()) {
        if (!active) return
        setMaintenance({ enabled: false })
        setMaintenanceChecked(true)
        return
      }

      if (!tid) {
        return
      }

      try {
        const s = await fetchMaintenanceStatus(tid)
        if (!active) return
        if (s.enabled && !prevEnabled) {
          authService.logout().catch(() => {})
        }
        prevEnabled = s.enabled
        setMaintenance(s)
      } finally {
        if (active) setMaintenanceChecked(true)
      }
    }

    if (tenantId) {
      setMaintenanceChecked(false)
    }

    const initialTenantId = tenantId || getRuntimeTenantIdSync() || undefined
    check(initialTenantId)

    const id = setInterval(() => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return
      check(tenantId || getRuntimeTenantIdSync() || undefined)
    }, MAINTENANCE_CHECK_INTERVAL)

    return () => { active = false; clearInterval(id) }
  }, [tenantId])

  // ── Maintenance events from shared content WebSocket ──────────────────────────
  useEffect(() => {
    if (!tenantId) return
    const handleMaintenanceModeChanged = (event: Event) => {
      if (isInternalStagingHostname()) return
      const data = (event as CustomEvent<MaintenanceState & { maintenanceStart?: string | null; tenantId?: string }>).detail
      if (data?.tenantId && data.tenantId !== tenantId) return
      setMaintenance({ enabled: data.enabled === true, reason: data.reason, estimatedEnd: data.estimatedEnd })
      setMaintWarn({ active: false, countdownMinutes: 0, secondsLeft: 0 })
      if (maintWarnTimerRef.current) {
        clearInterval(maintWarnTimerRef.current)
        maintWarnTimerRef.current = null
      }
      if (data.enabled) {
        authService.logout().catch(() => {})
      }
    }

    const handleMaintenanceWarning = (event: Event) => {
      if (isInternalStagingHostname()) return
      const data = (event as CustomEvent<MaintenanceWarning & { tenantId?: string }>).detail
      if (data?.tenantId && data.tenantId !== tenantId) return
      const totalSeconds = (data.countdownMinutes || 5) * 60
      setMaintWarn({
        active: true,
        reason: data.reason,
        estimatedEnd: data.estimatedEnd,
        maintenanceStart: data.maintenanceStart,
        countdownMinutes: data.countdownMinutes || 5,
        secondsLeft: totalSeconds,
      })
      if (maintWarnTimerRef.current) clearInterval(maintWarnTimerRef.current)
      maintWarnTimerRef.current = setInterval(() => {
        setMaintWarn(prev => {
          if (!prev.active) return prev
          const next = prev.secondsLeft - 1
          if (next <= 0) {
            if (maintWarnTimerRef.current) { clearInterval(maintWarnTimerRef.current); maintWarnTimerRef.current = null }
            return { ...prev, secondsLeft: 0 }
          }
          return { ...prev, secondsLeft: next }
        })
      }, 1000)
    }

    window.addEventListener('maintenance_mode_changed', handleMaintenanceModeChanged as EventListener)
    window.addEventListener('maintenance_warning', handleMaintenanceWarning as EventListener)
    return () => {
      window.removeEventListener('maintenance_mode_changed', handleMaintenanceModeChanged as EventListener)
      window.removeEventListener('maintenance_warning', handleMaintenanceWarning as EventListener)
      if (maintWarnTimerRef.current) { clearInterval(maintWarnTimerRef.current); maintWarnTimerRef.current = null }
    }
  }, [tenantId])

  // View As: เมื่อเปิดจาก admin ด้วย #/dashboard?viewAsToken=xxx — เก็บ token, โหลด profile, ไป /dashboard
  useEffect(() => {
    if (isLoading) return
    const token = authService.getViewAsTokenFromHash()
    if (import.meta.env.DEV) {
      console.log('[ViewAs] isLoading=false, token from hash:', token ? `${token.slice(0, 20)}...` : null)
    }
    if (!token) {
      setViewAsHandling(false)
      return
    }
    setViewAsError(null)
    authService.applyViewAsToken(token).then((result) => {
      if (import.meta.env.DEV) {
        console.log('[ViewAs] applyViewAsToken result:', result.ok, result.error || '')
      }
      if (result.ok) {
        // ใช้ location.hash เพื่อให้ HashRouter ได้รับ hashchange และไป /dashboard จริง
        window.location.hash = '#/dashboard'
      } else {
        setViewAsError(result.error || 'ไม่สามารถเข้า View As ได้')
      }
      setViewAsHandling(false)
    })
  }, [isLoading])

  useEffect(() => {
    if (themeLoadStarted) return
    themeLoadStarted = true
    themeLoadedRef.current = true
    loadTenantTheme()
  }, [])

  // เมื่ออยู่บน dev: ถ้าใช้ปุ่ม back/forward แล้ว URL ?tenant= เปลี่ยน ให้โหลด tenant ใหม่
  useEffect(() => {
    const isDevHost =
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.startsWith('127.0.0.') ||
        window.location.hostname.includes('localhost'))
    if (!isDevHost) return
    const onPopState = () => {
      const next = new URLSearchParams(window.location.search).get('tenant')
      const effectiveNext = next || getRuntimeTenantIdSync()
      if (effectiveNext !== tenantId) {
        themeLoadStarted = false
        loadTenantTheme()
      }
    }
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [tenantId])

  // Priority: domain-mappings API → host-scoped cache/runtime context → dev-only env/default
  const resolveTenantId = async (): Promise<string> => {
    const resolved = await resolveRuntimeTenantId()
    if (resolved) {
      if (import.meta.env.DEV) {
        console.log(`🏢 [user-modern] resolved tenant: ${window.location.hostname} → ${resolved}`)
      }
      return resolved
    }
    throw new Error(`Unable to resolve tenant for host "${window.location.hostname}" via domain-mappings`)
  }

  const loadTenantTheme = async () => {
    try {
      setIsLoading(true)
      setError(null)

      const tid = await resolveTenantId()
      setTenantId(tid)
      setRuntimeTenantId(tid)
      lotteryService.setTenantId(tid)

      // โหลด content จาก API แบบเดียวกับ user-classic (marquee, contactInfo, branding)
      const tenantContentResponse = await getTenantContent(tid)
      const tenantContentData = tenantContentResponse?.success ? tenantContentResponse.data : null

      const savedThemeId = normalizeHtdThemeId(localStorage.getItem(STORAGE_THEME_KEY))
      const adminThemeId = parseHtdThemeFromTemplate(tenantContentData?.frontendTemplate)
      const tenantDefaultThemeId = getDefaultThemeIdForTenant(tid)
      const preferredThemeId = savedThemeId || adminThemeId || tenantDefaultThemeId

      const themeMetadata = getThemeById(preferredThemeId) || getDefaultTheme()
      const rawSavedThemeId = localStorage.getItem(STORAGE_THEME_KEY)
      if (rawSavedThemeId && rawSavedThemeId !== themeMetadata.id) {
        localStorage.setItem(STORAGE_THEME_KEY, themeMetadata.id)
      }
      const tenantConfig = buildThemeConfig(tid, themeMetadata, tenantContentData)

      if (import.meta.env.DEV) {
        console.log('📢 Marquee from tenant content:', {
          fromApi: !!tenantContentData?.content?.marqueeText,
          marqueeText: tenantConfig.settings.marqueeText?.slice(0, 80) + (tenantConfig.settings.marqueeText?.length > 80 ? '...' : ''),
        })
      }
      setThemeConfig(tenantConfig)
      await loadThemeAssets(tenantConfig)
    } catch (err) {
      console.error('Failed to load tenant theme:', err)
      setError(err instanceof Error ? err.message : 'Failed to load theme')
      themeLoadedRef.current = false
      themeLoadStarted = false
      const catchFallbackTenantId = getRuntimeTenantIdSync()
      setTenantId(catchFallbackTenantId)
      lotteryService.setTenantId(catchFallbackTenantId)
      const defaultMetadata = getDefaultTheme()
      const defaultConfig = buildThemeConfig(catchFallbackTenantId || '', defaultMetadata, null)
      setThemeConfig(defaultConfig)
      try {
        await loadThemeAssets(defaultConfig)
      } catch {
        // ignore fallback load failure
      }
    } finally {
      setIsLoading(false)
    }
  }

  const loadThemeAssets = async (config: TenantThemeConfig) => {
    const ASSET_CONFIG = getAssetConfig()
    const themeMetadata = getThemeById(config.themeId)
    if (!themeMetadata) {
      throw new Error(`Theme ${config.themeId} not found in configuration`)
    }

    const { folder, assets } = themeMetadata
    const assetBase = `${ASSET_CONFIG.CDN_BASE_URL}/${folder}`

    for (let i = 0; i < assets.styles.length; i++) {
      const cssPath = assets.styles[i]
      const cssUrl = assetBase + cssPath
      const cssId = i === 0 ? 'bootstrap-css' : `theme-css-${i}`
      // ข้ามเฉพาะเมื่อ link ที่เราจัดการ (data-css-id) ชี้ไปที่ theme นี้แล้ว — ไม่ข้ามเพราะเจอ link จาก index.html (ไม่งั้นสลับมา Blue จะไม่เปลี่ยน เพราะไม่ลบ link ของ Red/LightBlue)
      const managedLink = document.querySelector(`link[data-css-id="${cssId}"]`)
      if (managedLink && (managedLink as HTMLLinkElement).href === cssUrl) continue
      try {
        await loadCSS(cssUrl, cssId)
      } catch (e) {
        if (ASSET_CONFIG.CDN_BASE_URL) {
          console.warn(
            `[Theme] Could not load CSS (${cssUrl}). Serve cdn-assets at ${ASSET_CONFIG.CDN_BASE_URL} to enable theme.`,
            e
          )
        }
      }
    }

    applyColorScheme(config.theme.colorScheme)

    if (config.theme.customCSS) {
      await loadCustomCSS(config.theme.customCSS)
    }

    try {
      const faviconUrl =
        config.theme.branding?.faviconUrl?.trim() || assetBase + assets.favicon
      updateFavicon(faviconUrl)
    } catch {
      // ignore favicon failure
    }
    document.title = config.theme.branding.siteName

    updateSocialMetaTags({
      title: config.theme.branding.siteName,
      description: config.settings?.welcomeMessage || config.settings?.marqueeText || config.theme.branding.siteName,
      imageUrl: config.theme.branding?.logoUrl,
      url: window.location.origin,
    })
  }

  const loadCSS = (url: string, id: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      document.querySelectorAll(`link[data-css-id="${id}"]`).forEach((el) => el.remove())
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = url
      link.setAttribute('data-css-id', id)
      link.onload = () => resolve()
      link.onerror = () => reject(new Error(`Failed to load CSS: ${url}`))
      document.head.appendChild(link)
    })
  }

  const loadCustomCSS = (cssContent: string): Promise<void> => {
    return new Promise((resolve) => {
      document.querySelectorAll('style[data-custom-css]').forEach((el) => el.remove())
      const style = document.createElement('style')
      style.setAttribute('data-custom-css', 'true')
      style.textContent = cssContent
      document.head.appendChild(style)
      resolve()
    })
  }

  const applyColorScheme = (colorScheme: ColorScheme) => {
    document.querySelectorAll('style[data-color-scheme]').forEach((el) => el.remove())
    const style = document.createElement('style')
    style.setAttribute('data-color-scheme', 'true')
    style.textContent = `
      :root {
        --color-primary: ${colorScheme.primary};
        --color-secondary: ${colorScheme.secondary};
        --color-accent: ${colorScheme.accent};
        --color-background: ${colorScheme.background};
        --color-text: ${colorScheme.text};
        --color-border: ${colorScheme.border};
        --color-success: ${colorScheme.success};
        --color-warning: ${colorScheme.warning};
        --color-danger: ${colorScheme.danger};
        --color-info: ${colorScheme.info};
        --htd-primary: ${colorScheme.primary};
        --htd-secondary: ${colorScheme.secondary};
        --htd-accent: ${colorScheme.accent};
        --htd-blue: ${colorScheme.primary};
        --htd-navy: ${colorScheme.secondary};
      }
    `
    document.head.appendChild(style)
    document.body.classList.add('theme-htd')
    document.body.dataset.htdTheme = colorScheme.primary.toLowerCase() === '#dc2626'
      ? 'red'
      : colorScheme.primary.toLowerCase() === '#0ea5e9'
        ? 'lightblue'
        : 'blue'
  }

  const updateFavicon = (url: string) => {
    let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      link.type = 'image/x-icon'
      document.head.appendChild(link)
    }
    link.href = url
  }

  const switchTheme = async (newThemeId: string) => {
    if (!themeConfig) return
    const themeMetadata = getThemeById(newThemeId)
    if (!themeMetadata || themeMetadata.status !== 'active') {
      setError(`ไม่พบธีม ${newThemeId}`)
      return
    }

    setIsLoading(true)
    try {
      const newConfig: TenantThemeConfig = {
        ...themeConfig,
        themeId: themeMetadata.id,
        theme: {
          ...themeConfig.theme,
          colorScheme: mapThemeColorsToColorScheme(themeMetadata.colorScheme),
        },
      }
      await loadThemeAssets(newConfig)
      setThemeConfig(newConfig)
      localStorage.setItem(STORAGE_THEME_KEY, themeMetadata.id)
    } catch (err) {
      console.error('Failed to switch HTD theme:', err)
      setError(`ไม่สามารถเปลี่ยนธีม ${themeMetadata.displayName} ได้`)
    } finally {
      setIsLoading(false)
    }
  }

  const resetThemeOverride = () => {
    localStorage.removeItem(STORAGE_THEME_KEY)
    window.location.reload()
  }

  const handleContentUpdate = useCallback((newContent: unknown) => {
    if (import.meta.env.DEV) {
      console.log('🔄 Content updated via WebSocket, refreshing UI...', newContent)
    }
    if (typeof newContent !== 'object' || newContent === null) return
    const c = newContent as Record<string, unknown>
    if (c._refreshTrigger) {
      loadTenantTheme()
      return
    }
    // ให้หน้าหวย (listall, Lotto) refetch รอบเมื่อแอดมินเปิด/ปิดประเภทหวย
    if (c.type === 'huay_type_updated') {
      window.dispatchEvent(
        new CustomEvent('huay_type_updated', {
          detail: {
            huayType: c.huayType,
            code: c.code,
            isActive: c.isActive,
            name: c.name,
            timestamp: c.timestamp,
          },
        })
      )
    }
    if ((c.type === 'lottery_round_updated' || c.type === 'lottery_round_update') && (c.round || c.data)) {
      window.dispatchEvent(
        new CustomEvent('lottery_round_updated', {
          detail: {
            round: (c.round ?? c.data) as Record<string, unknown>,
            sourceType: c.type,
          },
        })
      )
    }
    const content = c.content as Record<string, unknown> | undefined
    const branding = c.branding as { logo?: string; favicon?: string } | undefined
    const features = c.features as { webChatEnabled?: boolean; lineLoginEnabled?: boolean; wipWupMinutes?: number; wipWupMinutesOther?: number; depositEnabled?: boolean; withdrawEnabled?: boolean; lotteryEnabled?: boolean; casinoEnabled?: boolean; sessionIdleMinutes?: number; smsOtpEnabled?: boolean } | undefined
    const nextSiteTitle = (content?.siteTitle as string | undefined)?.trim()
    const nextMarquee = (content?.marqueeText as string | undefined) ?? (c.marqueeText as string | undefined)
    const nextContact =
      (content?.contactInfo as { line?: string; phone?: string } | undefined) ??
      (c.contactInfo as { line?: string; phone?: string } | undefined)
    const nextLogoUrl = sanitizeBrandingAssetUrl(branding?.logo)
    const nextFaviconUrl = sanitizeBrandingAssetUrl(branding?.favicon)
    const nextWebChat = typeof features?.webChatEnabled === 'boolean' ? features.webChatEnabled : undefined
    const nextWipWup = typeof features?.wipWupMinutes === 'number' && features.wipWupMinutes >= 1 && features.wipWupMinutes <= 120 ? features.wipWupMinutes : undefined
    const nextWipWupOther = typeof features?.wipWupMinutesOther === 'number' && features.wipWupMinutesOther >= 1 && features.wipWupMinutesOther <= 120 ? features.wipWupMinutesOther : undefined
    const nextDepositEnabled = typeof features?.depositEnabled === 'boolean' ? features.depositEnabled : undefined
    const nextWithdrawEnabled = typeof features?.withdrawEnabled === 'boolean' ? features.withdrawEnabled : undefined
    const nextLotteryEnabled = typeof features?.lotteryEnabled === 'boolean' ? features.lotteryEnabled : undefined
    const nextCasinoEnabled = typeof features?.casinoEnabled === 'boolean' ? features.casinoEnabled : undefined
    const nextSessionIdle =
      typeof features?.sessionIdleMinutes === 'number' && features.sessionIdleMinutes >= 0 && features.sessionIdleMinutes <= 120
        ? features.sessionIdleMinutes
        : undefined
    const nextLineLoginEnabled = typeof features?.lineLoginEnabled === 'boolean' ? features.lineLoginEnabled : undefined
    const nextSmsOtpEnabled = typeof features?.smsOtpEnabled === 'boolean' ? features.smsOtpEnabled : undefined
    const nextLiveTvEnabled = typeof (features as { liveTvEnabled?: boolean })?.liveTvEnabled === 'boolean'
      ? (features as { liveTvEnabled?: boolean }).liveTvEnabled
      : undefined
    const nextPredictionEnabled = typeof (features as { predictionEnabled?: boolean })?.predictionEnabled === 'boolean'
      ? (features as { predictionEnabled?: boolean }).predictionEnabled
      : undefined
    const nextRedEnvelopeEnabled = typeof (features as { redEnvelopeEnabled?: boolean })?.redEnvelopeEnabled === 'boolean'
      ? (features as { redEnvelopeEnabled?: boolean }).redEnvelopeEnabled
      : undefined
    const nextLuckyWheelEnabled = typeof (features as { luckyWheelEnabled?: boolean })?.luckyWheelEnabled === 'boolean'
      ? (features as { luckyWheelEnabled?: boolean }).luckyWheelEnabled
      : undefined
    const nextBerThongEnabled = typeof (features as { berThongEnabled?: boolean })?.berThongEnabled === 'boolean'
      ? (features as { berThongEnabled?: boolean }).berThongEnabled
      : undefined
    const nextScratchLotteryEnabled = typeof (features as { scratchLotteryEnabled?: boolean })?.scratchLotteryEnabled === 'boolean'
      ? (features as { scratchLotteryEnabled?: boolean }).scratchLotteryEnabled
      : undefined
    const nextHuayJackpotEnabled = typeof (features as { huayJackpotEnabled?: boolean })?.huayJackpotEnabled === 'boolean'
      ? (features as { huayJackpotEnabled?: boolean }).huayJackpotEnabled
      : undefined
    const nextLiveTvChannels = (features as { liveTvChannels?: unknown })?.liveTvChannels !== undefined
      ? parseLiveTvChannels((features as { liveTvChannels?: unknown }).liveTvChannels)
      : undefined
    const nextHuayYoutubeLive = (features as { huayYoutubeLive?: unknown })?.huayYoutubeLive !== undefined
      ? parseHuayYoutubeLive((features as { huayYoutubeLive?: unknown }).huayYoutubeLive)
      : undefined
    const nextLiveTvPlayerStartMuted = typeof (features as { liveTvPlayerStartMuted?: boolean })?.liveTvPlayerStartMuted === 'boolean'
      ? (features as { liveTvPlayerStartMuted?: boolean }).liveTvPlayerStartMuted
      : undefined
    const nextPaymentRates =
      content?.paymentRates !== undefined
        ? parsePaymentRatesContent(content.paymentRates as { type?: string; textContent?: string; imageUrl?: string })
        : undefined

    if (nextSiteTitle !== undefined && nextSiteTitle !== '') {
      document.title = nextSiteTitle
    }
    setThemeConfig((prev) => {
      if (!prev) return null
      const nextSettings = {
        ...prev.settings,
        ...(nextMarquee !== undefined && { marqueeText: nextMarquee }),
        ...(nextContact !== undefined && { contactInfo: nextContact }),
        ...(nextWebChat !== undefined && { webChatEnabled: nextWebChat }),
        ...(nextWipWup !== undefined && { wipWupMinutes: nextWipWup }),
        ...(nextWipWupOther !== undefined && { wipWupMinutesOther: nextWipWupOther }),
        ...(nextDepositEnabled !== undefined && { depositEnabled: nextDepositEnabled }),
        ...(nextWithdrawEnabled !== undefined && { withdrawEnabled: nextWithdrawEnabled }),
        ...(nextLotteryEnabled !== undefined && { lotteryEnabled: nextLotteryEnabled }),
        ...(nextCasinoEnabled !== undefined && { casinoEnabled: nextCasinoEnabled }),
        ...(nextSessionIdle !== undefined && { sessionIdleMinutes: nextSessionIdle }),
        ...(nextLineLoginEnabled !== undefined && { lineLoginEnabled: nextLineLoginEnabled }),
        ...(nextSmsOtpEnabled !== undefined && { smsOtpEnabled: nextSmsOtpEnabled }),
        ...(nextLiveTvEnabled !== undefined && { liveTvEnabled: nextLiveTvEnabled }),
        ...(nextPredictionEnabled !== undefined && { predictionEnabled: nextPredictionEnabled }),
        ...(nextRedEnvelopeEnabled !== undefined && { redEnvelopeEnabled: nextRedEnvelopeEnabled }),
        ...(nextLuckyWheelEnabled !== undefined && { luckyWheelEnabled: nextLuckyWheelEnabled }),
        ...(nextBerThongEnabled !== undefined && { berThongEnabled: nextBerThongEnabled }),
        ...(nextScratchLotteryEnabled !== undefined && { scratchLotteryEnabled: nextScratchLotteryEnabled }),
        ...(nextHuayJackpotEnabled !== undefined && { huayJackpotEnabled: nextHuayJackpotEnabled }),
        ...(nextLiveTvChannels !== undefined && { liveTvChannels: nextLiveTvChannels }),
        ...(nextHuayYoutubeLive !== undefined && { huayYoutubeLive: nextHuayYoutubeLive }),
        ...(nextLiveTvPlayerStartMuted !== undefined && { liveTvPlayerStartMuted: nextLiveTvPlayerStartMuted }),
        ...(nextPaymentRates !== undefined && { paymentRates: nextPaymentRates }),
      }
      let nextBranding = { ...prev.theme.branding }
      if (nextSiteTitle !== undefined) nextBranding = { ...nextBranding, siteName: nextSiteTitle }
      if (nextLogoUrl !== undefined && nextLogoUrl !== '') nextBranding = { ...nextBranding, logoUrl: nextLogoUrl }
      if (nextFaviconUrl !== undefined && nextFaviconUrl !== '') nextBranding = { ...nextBranding, faviconUrl: nextFaviconUrl }
      const changed =
        nextSettings.marqueeText !== prev.settings.marqueeText ||
        nextSettings.contactInfo !== prev.settings.contactInfo ||
        nextSettings.webChatEnabled !== prev.settings.webChatEnabled ||
        nextSettings.wipWupMinutes !== prev.settings.wipWupMinutes ||
        nextSettings.wipWupMinutesOther !== prev.settings.wipWupMinutesOther ||
        nextSettings.depositEnabled !== prev.settings.depositEnabled ||
        nextSettings.withdrawEnabled !== prev.settings.withdrawEnabled ||
        nextSettings.lotteryEnabled !== prev.settings.lotteryEnabled ||
        nextSettings.casinoEnabled !== prev.settings.casinoEnabled ||
        nextSettings.sessionIdleMinutes !== prev.settings.sessionIdleMinutes ||
        nextSettings.lineLoginEnabled !== prev.settings.lineLoginEnabled ||
        nextSettings.smsOtpEnabled !== prev.settings.smsOtpEnabled ||
        nextSettings.liveTvEnabled !== prev.settings.liveTvEnabled ||
        nextSettings.predictionEnabled !== prev.settings.predictionEnabled ||
        nextSettings.redEnvelopeEnabled !== prev.settings.redEnvelopeEnabled ||
        nextSettings.luckyWheelEnabled !== prev.settings.luckyWheelEnabled ||
        nextSettings.berThongEnabled !== prev.settings.berThongEnabled ||
        nextSettings.scratchLotteryEnabled !== prev.settings.scratchLotteryEnabled ||
        nextSettings.huayJackpotEnabled !== prev.settings.huayJackpotEnabled ||
        JSON.stringify(nextSettings.liveTvChannels) !== JSON.stringify(prev.settings.liveTvChannels) ||
        JSON.stringify(nextSettings.huayYoutubeLive) !== JSON.stringify(prev.settings.huayYoutubeLive) ||
        nextSettings.liveTvPlayerStartMuted !== prev.settings.liveTvPlayerStartMuted ||
        JSON.stringify(nextSettings.paymentRates) !== JSON.stringify(prev.settings.paymentRates) ||
        nextBranding.siteName !== prev.theme.branding.siteName ||
        nextBranding.logoUrl !== prev.theme.branding.logoUrl ||
        nextBranding.faviconUrl !== prev.theme.branding.faviconUrl
      if (!changed) return prev
      return {
        ...prev,
        theme: { ...prev.theme, branding: nextBranding },
        settings: nextSettings,
      }
    })
    if (nextFaviconUrl?.trim()) {
      updateFavicon(nextFaviconUrl)
    }
    if (nextSiteTitle || nextLogoUrl) {
      updateSocialMetaTags({
        title: nextSiteTitle || document.title,
        description: nextMarquee || document.title,
        imageUrl: nextLogoUrl,
        url: window.location.origin,
      })
    }
  }, [])

  useSmartWebSocket({
    tenantId,
    onContentUpdate: handleContentUpdate,
    enabled: !!tenantId && !!themeConfig,
  })

  const popupManagerEnabled = Boolean(tenantId)
  const {
    currentPopup,
    dismissPopup,
  } = usePopupManagerOptimized({
    tenantId,
    route: '/',
    enabled: popupManagerEnabled,
  })

  // ── Maintenance page — shown to ALL users (highest priority) ─────────────
  if (!maintenanceChecked && !isInternalStagingHostname()) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-dark">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading</span>
          </div>
          <p className="text-white">กำลังตรวจสอบสถานะระบบ...</p>
        </div>
      </div>
    )
  }

  if (maintenance.enabled) {
    return (
      <ModernMaintenancePage
        reason={maintenance.reason}
        estimatedEnd={maintenance.estimatedEnd}
        services={maintenance.services}
        logoUrl={themeConfig?.theme?.branding?.logoUrl}
        siteName={themeConfig?.theme?.branding?.siteName}
      />
    )
  }

  if (isLoading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-dark">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-white">กำลังโหลดธีม...</p>
        </div>
      </div>
    )
  }

  if (error || !themeConfig) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-danger">
        <div className="text-center text-white">
          <h4>เกิดข้อผิดพลาด</h4>
          <p>{error || 'ไม่สามารถโหลดธีมได้'}</p>
          <button className="btn btn-light" onClick={() => window.location.reload()}>
            ลองใหม่
          </button>
        </div>
      </div>
    )
  }

  const assetConfig = getAssetConfig()
  const hashQuery = window.location.hash.includes('?')
    ? window.location.hash.slice(window.location.hash.indexOf('?') + 1)
    : ''
  const showThemeSwitcher =
    import.meta.env.DEV ||
    new URLSearchParams(window.location.search).get('themeSwitcher') === '1' ||
    new URLSearchParams(hashQuery).get('themeSwitcher') === '1'

  if (viewAsHandling) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-dark text-white">
        <div className="text-center">
          <div className="spinner-border text-light mb-3" role="status" />
          <p className="mb-0">กำลังเข้า View As...</p>
        </div>
      </div>
    )
  }
  if (viewAsError) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-dark text-white">
        <div className="text-center p-4">
          <p className="text-warning mb-3">{viewAsError}</p>
          <a href="#/" className="btn btn-outline-light">กลับหน้าหลัก</a>
        </div>
      </div>
    )
  }

  return (
    <HashRouter>
      <ScrollToTop />
      <LineBridgeHashRedirect />
      {maintWarn.active && <MaintenanceWarningOverlay warning={maintWarn} />}
      {tenantId ? <ModernAnnouncementAlert tenantId={tenantId} key="announcement" /> : null}
      <Routes>
        <Route
          path="/login"
          element={<ModernLoginPage themeConfig={themeConfig} />}
        />
        <Route
          path="/passcode"
          element={<ModernPasscodePage themeConfig={themeConfig} />}
        />
        <Route
          path="/register"
          element={<ModernRegisterPage themeConfig={themeConfig} />}
        />
        <Route
          path="/register/complete"
          element={<ModernRegisterCompletePage themeConfig={themeConfig} />}
        />
        <Route
          path="/"
          element={
            <ModernLayout
              themeConfig={themeConfig}
              assetConfig={assetConfig}
            />
          }
        >
          <Route index element={<ModernHomePage themeConfig={themeConfig} assetConfig={assetConfig} />} />
          <Route path="howto" element={<ModernHowtoPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
          <Route path="lobby-huay" element={<ModernLobbyHuayLayout themeConfig={themeConfig} assetConfig={assetConfig} />}>
            <Route index element={<Navigate to="listall" replace />} />
            <Route path="listall" element={<ModernLobbyHuayListAllPage />} />
            <Route path="lottery-terms" element={<ModernLobbyHuayLotteryTermsPage />} />
            <Route path="bet" element={<ModernLobbyHuayBetPage />} />
            <Route path="set-lotto-game" element={<ModernLobbyHuaySetLottoGamePage />} />
            <Route path="yeekee" element={<ModernLobbyHuayYeekeePage />} />
            <Route path="yeekee/result" element={<ModernLobbyHuayYeekeeResultPage />} />
            <Route path="yeekee/bet" element={<ModernLobbyHuayBetPage />} />
            <Route path="set" element={<ModernLobbyHuaySetPage />} />
            <Route path="set/create" element={<ModernLobbyHuaySetEditPage />} />
            <Route path="set/edit/:id" element={<ModernLobbyHuaySetEditPage />} />
            <Route path="win-number" element={<ModernLobbyHuayWinNumberPage />} />
            <Route path="slip" element={<Outlet />}>
              <Route index element={<ModernLobbyHuaySlipPage />} />
              <Route path="detail/:slipId" element={<ModernLobbyHuaySlipDetailPage />} />
            </Route>
            <Route path="result" element={<ModernLobbyHuayResultPage />} />
          </Route>
          <Route path="contact" element={<ModernContactPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
          <Route element={<RequireAuthRoute />}>
            <Route path="dashboard" element={<ModernDashboardPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="lobby-casino" element={<ModernLobbyCasinoPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="promotion" element={<ModernPromotionPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="live-tv" element={<ModernLiveTvPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="cashback" element={<ModernCashbackPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="member" element={<ModernMemberPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="topup/reserve" element={<ModernDepositTimeoutPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="topup" element={<ModernTopupPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="topup/confirm" element={<ModernTopupConfirmPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="topup/slip" element={<ModernTopupSlipPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="withdraw" element={<ModernWithdrawPage themeConfig={themeConfig} assetConfig={assetConfig} />} />
            <Route path="reward" element={<ModernRewardLayout themeConfig={themeConfig} assetConfig={assetConfig} />}>
              <Route index element={<Navigate to="cashback" replace />} />
              <Route path="cashback" element={<RewardCashbackPage />} />
              <Route path="loss" element={<RewardLossPage />} />
              <Route path="refer" element={<RewardReferPage />} />
              <Route path="rank" element={<RewardRankPage />} />
            </Route>
            <Route path="history" element={<ModernHistoryLayout themeConfig={themeConfig} assetConfig={assetConfig} />}>
              <Route index element={<Navigate to="deposit" replace />} />
              <Route path="deposit" element={<HistoryDepositPage />} />
              <Route path="withdraw" element={<HistoryWithdrawPage />} />
              <Route path="credit" element={<HistoryCreditPage />} />
              <Route path="gamble" element={<HistoryGamblePage />} />
              <Route path="pending" element={<HistoryPendingPage />} />
              <Route path="games" element={<HistoryGamesLayout />}>
                <Route index element={<HistoryGamesIndexRedirect />} />
                <Route path="btd" element={<HistoryBtdPage />} />
                <Route path="red-envelope" element={<HistoryRedEnvelopePage />} />
                <Route path="lucky-wheel" element={<HistoryLuckyWheelPage />} />
                <Route path="scratch-lottery" element={<HistoryScratchLotteryPage />} />
                <Route path="huay-jackpot" element={<HistoryHuayJackpotPage />} />
                <Route path="ber-thong" element={<HistoryBerThongPage />} />
              </Route>
              <Route path="btd" element={<Navigate to="/history/games/btd" replace />} />
              <Route path="red-envelope" element={<Navigate to="/history/games/red-envelope" replace />} />
            </Route>
            <Route path="affiliate" element={<ModernAffiliateLayout themeConfig={themeConfig} assetConfig={assetConfig} />}>
              <Route index element={<Navigate to="overview" replace />} />
              <Route path="overview" element={<AffiliateOverviewPage />} />
              <Route path="member" element={<AffiliateMemberPage />} />
              <Route path="income" element={<AffiliateIncomePage />} />
              <Route path="topten" element={<AffiliateToptenPage />} />
              <Route path="withdrawal" element={<AffiliateWithdrawalPage />} />
            </Route>
            <Route path="points" element={<ModernPointsLayout themeConfig={themeConfig} assetConfig={assetConfig} />}>
              <Route index element={<Navigate to="moneytopoint" replace />} />
              <Route path="moneytopoint" element={<PointsMoneytopointPage />} />
              <Route path="pointtomoney" element={<PointsPointtomoneyPage />} />
              <Route path="rewards" element={<PointsRewardsPage />} />
              <Route path="reward-history" element={<PointsRewardHistoryPage />} />
              <Route path="games/prediction" element={<PredictionPage />} />
              <Route path="game/prediction" element={<Navigate to="/points/games/prediction" replace />} />
              <Route path="games/red-envelope" element={<RedEnvelopeGamePage />} />
              <Route path="games/red-envelope/history" element={<RedEnvelopeHistoryPage />} />
              <Route path="games/red-envelope-demo" element={<RedEnvelopeDemoPage />} />
              <Route path="games/lucky-wheel" element={<LuckyWheelGamePage />} />
              <Route path="games/scratch-lottery" element={<ScratchLotteryLobbyPage />} />
              <Route path="games/scratch-lottery/:productId" element={<ScratchLotteryGamePage />} />
              <Route path="games/huay-jackpot" element={<HuayJackpotLobbyPage />} />
              <Route path="games/ber-thong" element={<BerThongLobbyPage />} />
              <Route path="games/ber-thong/huay/:huayKey" element={<BerThongSheetsPage />} />
              <Route path="games/ber-thong/sheet/:sheetId" element={<BerThongGamePage />} />
            </Route>
            <Route path="lottery/prediction" element={<Navigate to="/points/games/prediction" replace />} />
          </Route>
        </Route>
      </Routes>

      {currentPopup && tenantId && (
        <PopupModal
          key={currentPopup._id}
          popup={currentPopup}
          tenantId={tenantId}
          onClose={dismissPopup}
        />
      )}

      {showThemeSwitcher && (
        <ThemeSwitcherFloat
          themeId={themeConfig.themeId}
          themes={getActiveThemes()}
          tenantId={themeConfig.tenantId}
          onSwitch={(id) => void switchTheme(id)}
          onReset={resetThemeOverride}
        />
      )}
    </HashRouter>
  )
}

function getDefaultThemeIdForTenant(tenantId: string | null): string {
  if (!tenantId) return getDefaultTheme().id
  return getDefaultTheme().id
}

function normalizeHtdThemeId(themeId: string | null | undefined): string | null {
  const value = String(themeId || '').trim()
  if (!value) return null
  if (value === 'huay-htd') return 'huay-today-blue'
  const theme = getThemeById(value)
  return theme?.status === 'active' ? theme.id : null
}

function parseHtdThemeFromTemplate(frontendTemplate: string | null | undefined): string | null {
  const value = String(frontendTemplate || '').trim().toLowerCase()
  if (!value) return null
  if (value.endsWith('/theme-lightblue') || value.endsWith('/theme-light-blue')) {
    return 'huay-today-lightblue'
  }
  if (value.endsWith('/theme-red')) return 'huay-today-red'
  if (value.endsWith('/theme-blue')) return 'huay-today-blue'
  return null
}

function sanitizeBrandingAssetUrl(url?: string | null): string {
  const raw = String(url || '').trim()
  if (!raw) return ''

  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'https://example.com'
    const currentProtocol = typeof window !== 'undefined' ? window.location.protocol : 'https:'
    const currentHost = typeof window !== 'undefined' ? window.location.hostname : ''
    const resolved = new URL(raw, base)
    const isLocalDevHost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(resolved.hostname)
    const isHttpOnHttpsPage = currentProtocol === 'https:' && resolved.protocol === 'http:'
    const isLocalhostLeak = isLocalDevHost && (!import.meta.env.DEV || resolved.hostname !== currentHost)

    if (isLocalhostLeak) return ''
    if (isHttpOnHttpsPage) return ''

    return resolved.href
  } catch {
    return raw.startsWith('/') ? raw : ''
  }
}

function parsePaymentRatesContent(
  raw?: { type?: string; textContent?: string; imageUrl?: string } | null
): TenantContentBlock | undefined {
  if (!raw || typeof raw !== 'object') return undefined
  const type = raw.type === 'image' ? 'image' : 'text'
  const textContent = String(raw.textContent || '')
  const imageUrl = sanitizeBrandingAssetUrl(raw.imageUrl) || String(raw.imageUrl || '').trim()
  if (!textContent && !imageUrl) return undefined
  return { type, textContent, imageUrl }
}

const DEFAULT_MARQUEE_TEXT =
  'ยินดีต้อนรับทุกท่านเข้าสู่เว็บ lenhuay.net เว็บหวยออนไลน์ที่มาแรงที่สุดในตอนนี้ มั่นคง ซื่อตรง รับประกันจ่ายจริงทุกโพย'

function buildThemeConfig(
  tenantId: string,
  themeMetadata: { id: string; name: string; displayName: string; folder: string; colorScheme: { primary: string; secondary: string }; assets: { logo: string; favicon: string } },
  tenantContentData: { name?: string; branding?: { logo?: string; favicon?: string }; content?: { siteTitle?: string; marqueeText?: string; contactInfo?: { line?: string; phone?: string }; paymentRates?: { type?: string; textContent?: string; imageUrl?: string } }; features?: { webChatEnabled?: boolean; lineLoginEnabled?: boolean; wipWupMinutes?: number; wipWupMinutesOther?: number; depositEnabled?: boolean; withdrawEnabled?: boolean; lotteryEnabled?: boolean; casinoEnabled?: boolean; sessionIdleMinutes?: number; smsOtpEnabled?: boolean; liveTvEnabled?: boolean; predictionEnabled?: boolean; redEnvelopeEnabled?: boolean; luckyWheelEnabled?: boolean; berThongEnabled?: boolean; scratchLotteryEnabled?: boolean; huayJackpotEnabled?: boolean; liveTvChannels?: unknown; huayYoutubeLive?: unknown; liveTvPlayerStartMuted?: boolean } } | null
): TenantThemeConfig {
  const ASSET_CONFIG = getAssetConfig()
  const colorScheme = mapThemeColorsToColorScheme(themeMetadata.colorScheme)
  const assetBase = `${ASSET_CONFIG.CDN_BASE_URL}/${themeMetadata.folder}`
  const logoUrl = sanitizeBrandingAssetUrl(tenantContentData?.branding?.logo) || assetBase + themeMetadata.assets.logo
  const faviconUrl = sanitizeBrandingAssetUrl(tenantContentData?.branding?.favicon) || assetBase + themeMetadata.assets.favicon
  const siteTitleFromContent = tenantContentData?.content?.siteTitle?.trim()
  const siteName = siteTitleFromContent
    ? siteTitleFromContent
    : tenantContentData?.name
      ? `${tenantContentData.name} :: หวยออนไลน์สไตล์โมเดิร์น`
      : `${themeMetadata.displayName} :: หวยออนไลน์สไตล์โมเดิร์น`
  const marqueeText =
    tenantContentData?.content?.marqueeText ??
    `ยินดีต้อนรับเข้าสู่เว็บไซต์ ${themeMetadata.displayName} เว็บหวยออนไลน์ที่มาแรงที่สุดในตอนนี้ มั่นคง ซื่อตรง ฉับไว รับประกันจ่ายจริงทุกโพย`
  const webChatEnabled = tenantContentData?.features?.webChatEnabled
  const wipWupMinutesRaw = tenantContentData?.features?.wipWupMinutes
  const wipWupMinutesOtherRaw = tenantContentData?.features?.wipWupMinutesOther
  const wipWupMinutes =
    typeof wipWupMinutesRaw === 'number' && wipWupMinutesRaw >= 1 && wipWupMinutesRaw <= 120
      ? wipWupMinutesRaw
      : 15
  const wipWupMinutesOther =
    typeof wipWupMinutesOtherRaw === 'number' && wipWupMinutesOtherRaw >= 1 && wipWupMinutesOtherRaw <= 120
      ? wipWupMinutesOtherRaw
      : 15
  const depositEnabled = tenantContentData?.features?.depositEnabled !== false
  const withdrawEnabled = tenantContentData?.features?.withdrawEnabled !== false
  const lotteryEnabled = tenantContentData?.features?.lotteryEnabled !== false
  const casinoEnabled = tenantContentData?.features?.casinoEnabled !== false
  const sessionIdleRaw = tenantContentData?.features?.sessionIdleMinutes
  const sessionIdleMinutes =
    typeof sessionIdleRaw === 'number' && sessionIdleRaw >= 0 && sessionIdleRaw <= 120
      ? sessionIdleRaw
      : 30
  const lineLoginEnabled = tenantContentData?.features?.lineLoginEnabled !== false
  const smsOtpEnabled = tenantContentData?.features?.smsOtpEnabled === true
  const liveTvChannels = parseLiveTvChannels(tenantContentData?.features?.liveTvChannels)
  const liveTvEnabled = tenantContentData?.features?.liveTvEnabled === true
  const predictionEnabled = tenantContentData?.features?.predictionEnabled === true
  const redEnvelopeEnabled = tenantContentData?.features?.redEnvelopeEnabled === true
  const luckyWheelEnabled = tenantContentData?.features?.luckyWheelEnabled === true
  const berThongEnabled = tenantContentData?.features?.berThongEnabled === true
  const scratchLotteryEnabled = tenantContentData?.features?.scratchLotteryEnabled === true
  const huayJackpotEnabled = tenantContentData?.features?.huayJackpotEnabled === true
  const huayYoutubeLive = parseHuayYoutubeLive((tenantContentData?.features as { huayYoutubeLive?: unknown } | undefined)?.huayYoutubeLive)
  const liveTvPlayerStartMuted = tenantContentData?.features?.liveTvPlayerStartMuted !== false
  const paymentRates = parsePaymentRatesContent(tenantContentData?.content?.paymentRates)

  return {
    tenantId,
    themeId: themeMetadata.id,
    theme: {
      baseTheme: 'modern',
      colorScheme,
      branding: {
        siteName,
        logoUrl,
        faviconUrl,
      },
    },
    settings: {
      marqueeText: marqueeText || DEFAULT_MARQUEE_TEXT,
      ...(tenantContentData?.content?.contactInfo && { contactInfo: tenantContentData.content.contactInfo }),
      ...(typeof webChatEnabled === 'boolean' && { webChatEnabled }),
      wipWupMinutes,
      wipWupMinutesOther,
      depositEnabled,
      withdrawEnabled,
      lotteryEnabled,
      casinoEnabled,
      sessionIdleMinutes,
      lineLoginEnabled,
      smsOtpEnabled,
      liveTvChannels,
      liveTvEnabled,
      predictionEnabled,
      redEnvelopeEnabled,
      luckyWheelEnabled,
      berThongEnabled,
      scratchLotteryEnabled,
      huayJackpotEnabled,
      huayYoutubeLive,
      liveTvPlayerStartMuted,
      ...(paymentRates && { paymentRates }),
    },
  }
}

function mapThemeColorsToColorScheme(colors: { primary: string; secondary: string }): ColorScheme {
  const primary = colors.primary.toLowerCase()
  if (primary === '#067fd0') return COLOR_SCHEMES['htd-today-blue']
  if (primary === '#0ea5e9') return COLOR_SCHEMES['htd-today-lightblue']
  if (primary === '#dc2626') return COLOR_SCHEMES['htd-today-red']
  return {
    ...COLOR_SCHEMES['htd-today-blue'],
    primary: colors.primary,
    secondary: colors.secondary,
    accent: COLOR_SCHEMES['htd-today-blue'].accent,
    background: COLOR_SCHEMES['htd-today-blue'].background,
    border: colors.primary,
  }
}

export default App
